import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';

import reducers from '../reducers';
import sagas from '../sagas';
import dataLayer from './data-layer';
import saveLocation from './save-location';

const sagaMiddleware = createSagaMiddleware();

let middleware = [sagaMiddleware, dataLayer, saveLocation];

if (process.env.NODE_ENV === 'development') {
  const { createLogger } = require('redux-logger'); // eslint-disable-line
  middleware = [...middleware, createLogger({ collapsed: true })];
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const initialState = window.INITIAL_STATE;
const store = createStore(
  reducers,
  initialState,
  composeEnhancers(applyMiddleware(...middleware))
);

window.registerSaga = saga => {
  sagaMiddleware.run(saga);
};

sagas.forEach(sagaMiddleware.run);

export default store;
